<mat-card *ngIf="logoImageUrl" class="text-center">
    <img class="firm-logo" src="{{logoImageUrl}}" alt="firm logo">
</mat-card>
<mat-card class="text-center">
    <mat-card-title>{{matterInfo?.lawFirm}}</mat-card-title>
    <ng-container *ngIf="matterInfo?.lawFirmAddress">
        <mat-card-subtitle *ngIf="matterInfo?.lawFirmAddress?.addressLine1">
            {{matterInfo?.lawFirmAddress?.addressLine1}}
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="matterInfo?.lawFirmAddress?.addressLine2">
            {{matterInfo?.lawFirmAddress?.addressLine2}}
        </mat-card-subtitle>
        <mat-card-subtitle
                *ngIf="matterInfo?.lawFirmAddress?.city && matterInfo?.lawFirmAddress?.provinceCode && matterInfo?.lawFirmAddress?.postalCode">
            <span *ngIf="matterInfo?.lawFirmAddress?.city">{{matterInfo?.lawFirmAddress?.city}}</span>
            <span *ngIf="matterInfo?.lawFirmAddress?.provinceCode">, {{matterInfo?.lawFirmAddress?.provinceCode}}</span>
            <span *ngIf="matterInfo?.lawFirmAddress?.postalCode">, {{matterInfo?.lawFirmAddress?.postalCode}}</span>
        </mat-card-subtitle>
        <mat-card-content>{{matterInfo?.projectName}}</mat-card-content>
    </ng-container>
    <ng-container *ngIf="matterInfo?.lawFirmFullAddress">
        <mat-card-subtitle>
            {{matterInfo?.lawFirmFullAddress}}
        </mat-card-subtitle>
    </ng-container>

</mat-card>
<mat-toolbar>
    <mat-toolbar-row class="display-block">
        <div class="width-80 display-inline padding-right-10">{{matterDescription}}</div>
        <div class="display-inline referral-submit-btn">
            <button mat-raised-button color="white" (click)="returnToOverview()">
                <span class="bold-font">Return to File Overview</span>
            </button>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
<mat-divider></mat-divider>
<mat-list>
    <mat-list-item *ngIf="isFileStatusVisible && matterInfo?.fileStatus">
        <div class="col-md-3 bold padding-left-0">File Status</div>
        <div class="col-md-9 list-item-description">{{matterInfo?.fileStatus}}</div>
    </mat-list-item>
    <mat-list-item *ngIf="matterInfo?.propertyAddress?.addressLine1">
        <div class="col-md-3 bold padding-left-0">Property Address</div>
        <div class="col-md-9 list-item-description">{{matterInfo?.propertyAddress?.fullAddress}}</div>
    </mat-list-item>
    <mat-list-item *ngIf="matterInfo?.legalDescription && !matterInfo?.isCustomMatter()">
        <div class="col-md-3 bold padding-left-0">Legal Description</div>
        <div class="col-md-9 list-item-description">{{matterInfo?.legalDescription}}</div>
    </mat-list-item>
    <mat-list-item *ngIf="matterInfo?.occupancyDate">
        <div class="col-md-3 bold padding-left-0">Occupancy Date</div>
        <div class="col-md-9 list-item-description">{{matterInfo?.occupancyDate | date : 'mediumDate'}}</div>
    </mat-list-item>
    <mat-list-item *ngIf="matterInfo?.closingDate">
        <div class="col-md-3 bold padding-left-0" *ngIf="!matterInfo?.isCustomMatter()">Closing Date</div>
        <div class="col-md-3 bold padding-left-0" *ngIf="matterInfo?.isCustomMatter()">Completion Date</div>
        <div class="col-md-9 list-item-description">{{matterInfo?.closingDate | date : 'mediumDate'}}</div>
    </mat-list-item>
    <mat-list-item *ngIf="matterInfo?.vendorSolicitor">
        <div class="col-md-3 bold padding-left-0">Solicitor</div>
        <div class="col-md-9 list-item-description">{{matterInfo?.vendorSolicitor?.name}}</div>
    </mat-list-item>
    <mat-list-item *ngIf="matterInfo?.lawClerk">
        <div class="col-md-3 bold padding-left-0" dp-province-field-label="matterInfo.lawClerk" [label-province-code]="matterInfo.provinceCode">Law Clerk</div>
        <div class="col-md-9 list-item-description">{{matterInfo?.lawClerk?.name}}</div>
    </mat-list-item>
</mat-list>
<mat-divider></mat-divider>
<mat-toolbar *ngIf="matterInfo && matterInfo.appointments && matterInfo.appointments.length">
    <mat-toolbar-row>
        <span>Upcoming appointments</span>
    </mat-toolbar-row>
</mat-toolbar>
<mat-list *ngIf="matterInfo && matterInfo.appointments && matterInfo.appointments.length">
    <mat-list-item *ngFor="let appointment of matterInfo.appointments">
        <div class="col-md-2 list-item-description">{{appointment.startDate | date : 'mediumDate'}}</div>
        <div class="col-md-3 list-item-description">{{appointment.startTime}}-{{appointment.endTime}}</div>
        <div *ngIf="!isVortualMeeting(appointment)" class="col-md-2 list-item-description">{{appointment.eventSubtype}}</div>
        <div *ngIf="isVortualMeeting(appointment)" class="col-md-3 list-item-description"><a class="meeting-link" href="{{appointment.meetingLink}}" target="_blank">{{appointment.eventSubtype}}</a>&nbsp;&nbsp;<img class="{{getMettingIconSize(appointment.eventLocation)}}" src="{{getMettingIcon(appointment.eventLocation)}}"></div>
        <div class="col-md-4 list-item-description large-screen-only">{{appointment.scheduledForSolicitorName}}</div>
    </mat-list-item>
</mat-list>

